import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import {
    BrowserRouter as Router,
    Navigate,
    Route,
    Routes,
    useLocation,
    useParams,
} from 'react-router-dom';
import App from './App';
import SupportPage from './components/SupportPage';
import NotFound from './components/NotFound';
import { getApp } from './data/apps';
import './index.css';
import './styles/themes.css'; // must load last: themes override the base layers

/** Every app support page resolves through one route. */
function SupportRoute() {
    const { slug } = useParams();
    const app = getApp(slug); // case-insensitive, so legacy links still resolve
    return app ? <SupportPage app={app} /> : <NotFound />;
}

/** Land at the top of the page after a client-side navigation. */
function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) return;
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, [pathname, hash]);

    return null;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Router>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<App />} />
                <Route path="/support" element={<Navigate to="/" replace />} />
                <Route path="/support/:slug" element={<SupportRoute />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Router>
    </React.StrictMode>
);
